import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import PropTypes from 'prop-types';
import {PRIMARYCOLOR} from "../helpers/ThemeSettings";
import {Flex} from "reflexbox";
import {Done} from "@mui/icons-material";
import {useImageLoad} from "../../helpers/helpers";

const BORDER_THICKNESS = '20px';

const SkeletonImage = ({
  src,
  alt,
  id,
  style,
  skeletonWidth,
  skeletonHeight = '260px',
  greenOverlay,
  blueOverlay,
  noCheck,
  greenBorder,
  imgWidth,
  imgHeight,
  imgStyle,
}) => {
  const {imgRef, loaded, error, onLoad, onError, showSkeleton} = useImageLoad(src);
  const showOverlay = greenOverlay || blueOverlay;
  const overlayInset = greenBorder ? BORDER_THICKNESS : 0;

  return (
    <Flex
      id={id}
      style={{flexDirection: 'column', height: '100%', position: 'relative', ...style}}
    >
      {showSkeleton && (
        <Skeleton
          variant="rect"
          height={skeletonHeight}
          width={skeletonWidth || '100%'}
        />
      )}
      <img
        ref={imgRef}
        src={src}
        alt={alt || ''}
        onLoad={onLoad}
        onError={onError}
        style={{
          width: imgWidth || '100%',
          height: imgHeight,
          boxSizing: 'border-box',
          border: greenBorder && (`solid ${BORDER_THICKNESS} ${PRIMARYCOLOR}`),
          display: 'block',
          opacity: loaded || error ? 1 : 0,
          position: showSkeleton ? 'absolute' : 'static',
          top: showSkeleton ? 0 : undefined,
          left: showSkeleton ? 0 : undefined,
          ...imgStyle,
        }}
      />
      {showOverlay && (
        <Flex
          style={{
            position: 'absolute',
            top: overlayInset,
            left: overlayInset,
            right: overlayInset,
            bottom: overlayInset,
            backgroundColor: (greenOverlay && '#00968861') || (blueOverlay && '#005ea387'),
            justifyContent: 'center',
            alignItems: 'center',
            pointerEvents: 'none',
            zIndex: 2,
          }}
        >
          {!noCheck && <Done style={{color: 'white', fontSize: '80px'}}/>}
        </Flex>
      )}
    </Flex>
  );
};

SkeletonImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.object,
  skeletonWidth: PropTypes.string,
  skeletonHeight: PropTypes.string,
  greenOverlay: PropTypes.bool,
  blueOverlay: PropTypes.bool,
  noCheck: PropTypes.bool,
  greenBorder: PropTypes.bool,
  imgWidth: PropTypes.string,
  imgHeight: PropTypes.string,
  imgStyle: PropTypes.object,
};

export default SkeletonImage;
